export default {"src":"/_next/static/media/0x49d5c2bdffac6ce2bfdb6640f4f80f226bc10bab.8d8e3ad1.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};